import React from 'react'
import { Add, FilterAltOff } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material'
import { defaultGridButtonsTheme } from '../../../../../utils/reporting/muiThemeConfigs'
import { LoadingButton } from '@mui/lab'

const Button = ({
    text,
    iconComponent,
    display = true,
    action,
    extraClass,
    size = 'normal',
    loading=false
}) => {
    if (!display) {
        return null
    }
    return (
        <LoadingButton 
            loading={loading}
            className={`${extraClass}`} 
            size={size} 
            variant='outlined'
            loadingPosition='start'
            onClick={action}
            startIcon={iconComponent ? React.createElement(iconComponent) : null}
            >
            {text}
        </LoadingButton>
    )
}

const GridControls = ({ createLink, clearFunction }) => {
    return (
        <ThemeProvider theme={defaultGridButtonsTheme}>
            <div className="level-right gridControls">
                {/* <div className="level-item">
                    <Link to={createLink}>
                        <Button
                            text={'Create'}
                            size="small"
                            iconComponent={Add}
                            action={() => {}}
                        />
                    </Link>
                </div> */}
                <div className="level-item">
                        <Button
                            text={'Clear Filters'}
                            size="small"
                            iconComponent={FilterAltOff}
                            action={() => clearFunction()}
                        />
                </div>
            </div>
        </ThemeProvider>
    )
}

export default GridControls
